/**
 * This component displays the message a
 */
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-dealer-locked-message',
  templateUrl: './dealer-locked-message.component.html',
  styleUrls: ['./dealer-locked-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})
export class DealerLockedMessageComponent {
  @Input() lockReason: string;
}
